import * as requestFromServer from "./staffUsersCrud";
import { staffUsersSlice, callTypes } from "./staffUsersSlice";
import { NotificationManager } from "react-notifications";
import { async } from "react-tempusdominus-bootstrap";

const { actions } = staffUsersSlice;


export const updateRole = role => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateRole(role)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      // dispatch(actions.staffUserUpdated({ role }));
      return true;
    })
    .catch(error => {
      // error.clientMessage = "Can't update staffUser";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const updatedPermissions = async () => {
  // console.log("getPermissionList>>>>>>>>>>>>>>>>>>>>>>>>>>")
  if (localStorage?.getItem("token")) {
    try {
      const userdata = JSON.parse(localStorage.getItem("userData"));
      const countrydata = JSON.parse(localStorage.getItem("country"));
      const companydata = JSON.parse(localStorage.getItem("company"));
      // console.log("getPermissionList>>>>>>>>>>>>>>>>>>>>>>>>>>-------com----con------u-----",companydata,countrydata,userdata)
      let payload = {
       userId:userdata.id
      }
      // const userCompany = userdata?.company || [];
      // const isAdmin = helperFunc.isAdmin();
      return requestFromServer
        .getPermissionList(payload)
        .then((response) => {
          if (response && response?.data) {
            localStorage.setItem("permissions", JSON.stringify(response.data));
            const permission = JSON.parse(localStorage.getItem("permissions"));
            console.log("permissionUpdated>>>>>>>>>>>>>>>>>>>>>>>>>>");
            window.location.reload();
          } else {
            console.log("permissionUpdated>>>>>permission not found>>>>>>>>>>>>>>>>>>>>>");
            localStorage.setItem("permissions", JSON.stringify({
              pagePermission: ["dashborad.home.list"],
              buttonPermission: ["dashborad.home.list"],
              apiPermission: [],
              company: [],
              country: [],
              role: ""
            }));
          }
          return true;
        })
        .catch(error => {
          localStorage.setItem("permissions", JSON.stringify({
            pagePermission: ["dashborad.home.list"],
            buttonPermission: ["dashborad.home.list"],
            apiPermission: [],
            company: [],
            country: [],
            role: ""
          }));
          return false;
        });
      // console.log("getPermissionList>>>>>>>>>>>>>>>>>>>>>>>>>>--------res--------------",response);

    } catch (error) {
      localStorage.setItem("permissions", JSON.stringify({
        pagePermission: ["dashborad.home.list"],
        buttonPermission: ["dashborad.home.list"],
        apiPermission: [],
        company: [],
        country: [],
        role: ""
      }));
    }
  } else {
    window.location.reload();
  }

};

export const fetchPermissions = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchPermissions(queryParams)
    .then(response => {
      console.log("response::122er", response)
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.permissionsFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      // NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchPermissionsList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchModulePermissions(queryParams)
    .then(response => {
      console.log("response::122er", response)
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      console.log("permissions",entities)
      dispatch(actions.permissionsFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      // NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchRolePermissions = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchRolePermissions(queryParams)
    .then(response => {
      console.log("response::122er", response)
      // const { totalCount, entities } = response.data;
      // const totalCount = response.totalRecord;
      const roleList = response.data;
      dispatch(actions.roleFetched({ roleList }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      // NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCompanyList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.fetchCompanyList(queryParams)
    .then(response => {
      console.log("response::All Company List", response)
      // const { totalCount, entities } = response.data;
      const companyList = response;
      console.log("fetchCompanyList", companyList)
      dispatch(actions.CompanyList({ companyList }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCompanyDropdownList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.fetchCompanyDropdownList(queryParams)
    .then(response => {
      console.log("response::All Company List", response)
      // const { totalCount, entities } = response.data;
      const companyDropdownList = response;
      console.log("fetchCompanyDropdownList", companyDropdownList)
      dispatch(actions.CompanyDropdownList({ companyDropdownList }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCompanyLastActiveList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCompanyDropdownLastActiveDate(queryParams)
    .then((response) => {
      console.log("response::All Company List", response);
      // const { totalCount, entities } = response.data;
      const companyDropdownList = response;
      console.log("fetchCompanyDropdownList", companyDropdownList);
      dispatch(actions.CompanyDropdownList({ companyDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchRoleDropdownList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.fetchRoleDropdownList(queryParams)
    .then(response => {
      console.log("response::All Company List", response)
      // const { totalCount, entities } = response.data;
      const roleDropdownList = response;
      console.log("fetchRoleDropdownList", roleDropdownList)
      dispatch(actions.RoleDropdownList({ roleDropdownList }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchCountriesDropdownList = (queryParams) => (dispatch) => {
  return requestFromServer
    .fetchCountriesDropdownList(queryParams)
    .then((response) => {
      const countryDropdownList = response;
      dispatch(actions?.CountryDropdownList({ countryDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : "An error occurred while fetching countries."; // Default error message
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchCountryList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.fetchCountryList(queryParams)
    .then(response => {
      console.log("response::All Company List", response)
      // const { totalCount, entities } = response.data;
      const countryList = response;
      console.log("fetchCountryList", countryList)
      dispatch(actions.CountryList({ countryList }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCountryListDropdownList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.fetchCountryListDropdownList(queryParams)
    .then(response => {
      console.log("response::All Company List", response)
      // const { totalCount, entities } = response.data;
      const countryDropdownList = response;
      console.log("fetchCountryListDropdownList", countryDropdownList)
      dispatch(actions.CountryDropdownList({ countryDropdownList }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchStaffUsers = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAllStaffUsers(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.staffUsersFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      console.log('errMsg:', errMsg)
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchStaffUsersExport = queryParams => dispatch => {
  //dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAllStaffUsersExport(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const exportData = response.data;
     // const entities = response.data;
      dispatch(actions.staffUsersFetchedExport({ exportData }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      console.log('errMsg:', errMsg)
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};


// export const fetchStaffUsers = queryParams => dispatch => {
//   console.log('queryParams sdsds:', queryParams)
//   dispatch(actions.emptyList());
//   dispatch(actions.startCall({ callType: callTypes.list }));
//   return requestFromServer
//     .getAllStaffUsers(queryParams)
//     .then(response => {
//       console.log("response::122 qqq", response)
//       // const { totalCount, entities } = response.data;
//       const totalCount = response.totalRecord;
//       const entities = response.data;
//       dispatch(actions.staffUsersFetched({ totalCount, entities }));
//     })
//     .catch(error => {
//       const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
//       console.log('errMsg:', errMsg)
//       NotificationManager.error(errMsg, 'Error');
//       dispatch(actions.catchError({ error, callType: callTypes.list }));
//     });
// };

export const fetchAppUsers = queryParams => dispatch => {
  if (queryParams?.dateRange && queryParams?.dateRange !== undefined && queryParams?.dateRange !== null) {
    queryParams.fromDate = queryParams.dateRange.from;
    queryParams.toDate = queryParams.dateRange.to;
    delete queryParams.dateRange;
  }
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAllAppUsers(queryParams)
    .then(async response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      await entities.forEach(object => {
        object.selectedCompanyBaseUrl = queryParams?.selectedCompanyBaseUrl;
      });
      dispatch(actions.appUsersFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;

      if (errMsg == 'Network Error') {
        NotificationManager.error("Selected company’s base URL is invalid or " + errMsg, 'Error');
      } else {
        NotificationManager.error(errMsg, 'Error');
      }
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const createUserIdAction = queryParams => dispatch => {
 console.log("createUserId->createUserIdAction")
  if (queryParams?.limit  !== undefined && queryParams?.dateRange !== null) {
    queryParams.limit = 5000
  }
 //dispatch(actions.emptyList());
  //dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .createUserIdfun(queryParams)
    .then(async response => {
      NotificationManager.success("5000 user_id created success" ,1000);
      
      // // const { totalCount, entities } = response.data;
      // const totalCount = response.totalRecord;
      // const entities = response.data;
      // await entities.forEach(object => {
      //   object.selectedCompanyBaseUrl = queryParams?.selectedCompanyBaseUrl;
      // });
      // dispatch(actions.appUsersFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;

      if (errMsg == 'Network Error') {
        NotificationManager.error("Selected company’s base URL is invalid or " + errMsg, 'Error');
      } else {
        NotificationManager.error(errMsg, 'Error');
      }
     // dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const createSignupMethodAction = queryParams => dispatch => {
   console.log("createUserId->createSignupMethodAction")
    if (queryParams?.limit  !== undefined && queryParams?.dateRange !== null) {
      queryParams.limit = 5000
    }
   //dispatch(actions.emptyList());
    //dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer
      .createSignUpfun(queryParams)
      .then(async response => {
        NotificationManager.success("5000  signup method processed successfully" ,1000);
        
        // // const { totalCount, entities } = response.data;
        // const totalCount = response.totalRecord;
        // const entities = response.data;
        // await entities.forEach(object => {
        //   object.selectedCompanyBaseUrl = queryParams?.selectedCompanyBaseUrl;
        // });
        // dispatch(actions.appUsersFetched({ totalCount, entities }));
      })
      .catch(error => {
        const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
  
        if (errMsg == 'Network Error') {
          NotificationManager.error("Selected company’s base URL is invalid or " + errMsg, 'Error');
        } else {
          NotificationManager.error(errMsg, 'Error');
        }
       // dispatch(actions.catchError({ error, callType: callTypes.list }));
      });
  };

export const fetchRequestUser = queryParams => dispatch => {
  if (queryParams?.dateRange && queryParams?.dateRange !== undefined && queryParams?.dateRange !== null) {
    queryParams.fromDate = queryParams.dateRange.from;
    queryParams.toDate = queryParams.dateRange.to;
    delete queryParams.dateRange;
  }
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getDeleteRequest(queryParams)
    .then(async response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.deleteRequestFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchMainDashboardUser = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getMainDashboardUser(queryParams)
    .then(response => {
      console.log("response::122", response)
      // const { totalCount, entities } = response.data;
      const entities = response;
      dispatch(actions.mainDashboardUserFetched({ entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchMainDashboardWallet = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getMainDashboardWallet(queryParams)
    .then(response => {
      console.log("response::122", response)
      // const { totalCount, entities } = response.data;
      const walletData = response;
      dispatch(actions.mainDashboardFetchedWallet({ walletData }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchMainDashboardWalletRmg = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getMainDashboardWalletRmg(queryParams)
    .then(response => {
      console.log("response::122", response)
      // const { totalCount, entities } = response.data;
      const walletDataRmg = response;
      dispatch(actions.mainDashboardFetchedWalletRmg({ walletDataRmg }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};


export const fetchUserLogList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUserLogs(queryParams)
    .then(response => {
      const totalCount = response.data.count;
      const entities = response.data.list;
      dispatch(actions.userLogFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUserQueriesList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUserQueries(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.data.count;
      const entities = response.data.list;
      dispatch(actions.userQueriesFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUserContactList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUserContacts(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.data.count;
      const entities = response.data.list;
      dispatch(actions.userContactsFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUserContestList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUserContests(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.data.count;
      const entities = response.data.list;
      dispatch(actions.userContestsFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUserRecentContestList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUserRecentContests(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.data.count;
      const entities = response.data.list;
      dispatch(actions.userContestsFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUserUpcomingContestList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUserUpcomingContests(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.data.count;
      const entities = response.data.list;
      dispatch(actions.userContestsFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUserTournamnetList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUserTournamnets(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.data.count;
      const entities = response.data.list;
      dispatch(actions.userTournamnetsFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchUserTransactionsList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUserTransactions(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response.data.count;
      const entities = response.data.list;
      dispatch(actions.userTransactionsFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchStaffUser = id => dispatch => {
  if (!id) {
    return dispatch(actions.staffUserFetched({ staffUserForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getStaffUserById(id)
    .then(response => {
      const staffUser = response.data;
      dispatch(actions.staffUserFetched({ staffUserForEdit: { item: staffUser } }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteStaffUser = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteStaffUser(id)
    .then(response => {
      NotificationManager.success('success', 'Data deleted successfully!');
      console.log('id:', id)
      dispatch(actions.staffUserDeleted({ id }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createStaffUser = staffUserForCreation => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createStaffUser(staffUserForCreation)
    .then(response => {
      const { staffUser } = response.data;
      // NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.staffUserCreated({ staffUser }));
      return true;
    })
    .catch(error => {
      console.log('error---------:', error)
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateStaffUser = staffUser => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStaffUser(staffUser)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.staffUserUpdated({ staffUser }));
      return true;
    })
    .catch(error => {
      // error.clientMessage = "Can't update staffUser";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const updateAppUser = appUser => dispatch => {
  console.log('appUser ddd:', appUser)
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateAppUser(appUser)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.appUserUpdated({ appUser }));
      return true;
    })
    .catch(error => {
      // error.clientMessage = "Can't update staffUser";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const inActiveRequest = appUser => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .inActiveDeleteRequest(appUser)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      // dispatch(actions.appUserUpdated({ appUser }));
      return true;
    })
    .catch(error => {
      // error.clientMessage = "Can't update staffUser";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false;
    });
};

export const updateStaffUsersStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForStaffUsers(ids, status)
    .then(() => {
      dispatch(actions.staffUsersStatusUpdated({ ids, status }));
    })
    .catch(error => {
      // error.clientMessage = "Can't update staffUsers status";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteStaffUsers = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteStaffUsers(ids)
    .then(() => {
      dispatch(actions.staffUsersDeleted({ ids }));

    })
    .catch(error => {
      // error.clientMessage = "Can't delete staffUsers";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};


export const fetchStaffUserCompany = id => dispatch => {
  if (!id) {
    return dispatch(actions.staffUserFetchedCompany({ staffUserCompany: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getStaffUserCompany(id)
    .then(response => {
      const commpany = response.data;
      dispatch(actions.staffUserFetchedCompany({ staffUserCompany: { item: commpany } }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};




export const clearfetchStaffUsers = () => dispatch => {
  dispatch(actions.clearfetchStaffUsers({ callType: callTypes.action }));
};
